/**
 * Supabase client.
 *
 * Reads the project URL and anon key from Vite env vars at build time:
 *   VITE_SUPABASE_URL
 *   VITE_SUPABASE_ANON_KEY
 *
 * Set these in:
 *   - Cloudflare Pages → Settings → Environment Variables (production)
 *   - .env.local at the project root (local dev — never committed)
 *
 * The anon key is designed to be public; row-level security in the
 * database is what actually protects data. Never use the service_role
 * key in frontend code.
 */

import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL || "";
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || "";

export const isSupabaseConfigured = Boolean(url && anonKey);

export const supabase = isSupabaseConfigured
  ? createClient(url, anonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    })
  : null;

if (!isSupabaseConfigured && typeof window !== "undefined") {
  // eslint-disable-next-line no-console
  console.warn(
    "Supabase is not configured. Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY env vars.",
  );
}
